import { useState } from "react";
import notFound from "../../assets/images/common/image-not-found.png";
import { IoMdCheckmark } from "react-icons/io";
import { RiVipCrownFill } from "react-icons/ri";
import { FaRegFile } from "react-icons/fa";
import star from "../../assets/images/category/star.png";

const BlurImage = ({ isTransitObjectSelectHandler, image, src }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div>
      {/* Dummy placeholder */}
      {!isLoaded && (
        <div
          style={{
            height: "300px",
            // width: "330px",
            backgroundColor: "lightgray",
            borderRadius: "12px",
            marginBottom: "20px",
            marginTop: "20px",
          }}
        ></div>
      )}

      {/* Actual image (always rendered so onLoad can fire) */}
      <img
        className="masonry-image"
        src={src}
        onClick={() => isTransitObjectSelectHandler(image)}
        alt=""
        onLoad={() => setIsLoaded(true)}
        style={{
          opacity: isLoaded ? 1 : 0,
          transition: "opacity 0.5s ease-in-out",
          display: isLoaded ? "block" : "none",
        }}
      />
    </div>
  );
};

const ImageCard = ({
  image,
  admin,
  sortBy,
  order,
  limit,
  count,
  selectedOption,
  data,
  page,
  selectedContents,
  formik,
  location,
  userData,
  conservation,
  search,
  onSelect,
}) => {
  return (
    <>
      <div className="flip-card">
        <div className="flip-card-inner">
          <div className="masonry-title-box">
            {image?.reference_image ? (
              <BlurImage
                isTransitObjectSelectHandler={onSelect}
                sortBy={sortBy}
                order={order}
                limit={limit}
                count={count}
                selectedOption={selectedOption}
                data={data}
                page={page}
                image={image}
                selectedContents={selectedContents}
                formik={formik}
                location={location}
                userData={userData}
                admin={admin}
                conservation={conservation}
                search={search}
                src={image?.reference_image}
              />
            ) : (
              <img
                className="masonry-image"
                onClick={() => onSelect(image)}
                src={notFound}
                alt="error-image"
              />
            )}

            <div
              className="object-transit-select-box"
              onClick={() => onSelect(image)}
            >
              {image?.isSelected && (
                <div className="object-transit-select-mark">
                  <IoMdCheckmark />
                </div>
              )}
            </div>

            {image.iconic_object && (
              <div className="masonry-key">
                <RiVipCrownFill />
              </div>
            )}

            {image?.stability === 1 && (
              <p
                className="masonry-key-condition condition-one"
                style={{ right: image?.iconic_object ? "45px" : "10px" }}
              >
                1
              </p>
            )}
            {image?.stability === 2 && (
              <p
                className="masonry-key-condition condition-two"
                style={{ right: image?.iconic_object ? "45px" : "10px" }}
              >
                2
              </p>
            )}
            {image?.stability === 3 && (
              <p
                className="masonry-key-condition condition-three"
                style={{ right: image?.iconic_object ? "45px" : "10px" }}
              >
                3
              </p>
            )}

            {image?.is_emergency && (
              <p
                className="masonry-key-condition condition-emergency"
                style={{ right: image?.iconic_object ? "45px" : "10px" }}
              >
                Emergency
              </p>
            )}
          </div>
        </div>
      </div>

      <div className="masonry-title">
        <h6>{image.object_name}</h6>
        <p className="object-id">{image.accession_number}</p>
      </div>

      {(image.prime_category_name || image.category_name) && (
        <p style={{ display: "flex", gap: "7px" }}>
          <span className="truncate-text">
            {image.prime_category_name}
            {image.prime_category_name && image.category_name && " - "}
            {image.category_name}
          </span>

          {image?.key_category === "True" && (
            <img style={{ height: "15px" }} src={star} alt="key-category" />
          )}
        </p>
      )}
    </>
  );
};

export default ImageCard;
